import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Layout } from "antd";
import Navbar from "./adminNavbar";
import Sidebar from "./adminSidebar";
import usePermissions from "@/config/usePermissions";
import Preloader from "@/components/UI/Loader/PreLoader";

const { Content } = Layout;

const AdminLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const { hasAnyPermissions } = usePermissions();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      if (mobile) {
        setCollapsed(true);
      }
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };
  useEffect(() => { 
    setTimeout(() => {
      setIsLoading(false);
    },5000);
  }, []);

  return (
    <Layout className="min-h-screen bg-gray-50">
      {isLoading ? <Preloader/> : (<>
        {/* Sidebar - Only show if user has permissions */}
        {hasAnyPermissions && (
          <div
            className={`
            fixed left-0 top-0 bottom-0 z-40 
            transition-transform duration-300 ease-in-out
            ${collapsed ? "-translate-x-full" : "translate-x-0"}
          `}
            style={{ width: "256px" }}
          >
            <Sidebar collapsed={collapsed} />
          </div>
        )}

        {/* Mobile Overlay */}
        {!collapsed && isMobile && hasAnyPermissions && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-30"
            onClick={toggleSidebar}
          />
        )}

        {/* Main Content */}
        <Layout
          className={`
          transition-all duration-300 ease-in-out
          ${!collapsed && !isMobile && hasAnyPermissions ? "ml-64" : "ml-0"}
        `}
        >
          <Navbar
            collapsed={collapsed}
            toggleSidebar={toggleSidebar}
            isMobile={isMobile}
          />
          <Content className="bg-gray-50 py-3 h-[calc(100vh-80px)]">
            <Outlet />
          </Content>
        </Layout>


      </>)}
    </Layout>
  );
};

export default AdminLayout;
